import httpClient from '@/http-client'

export const get = (Options = {}) => {
  return httpClient
    .get('/api/sub-programs', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const store = data => {
  return httpClient
    .post('/api/sub-programs', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const find = (id, Options = {}) => {
  return httpClient
    .get(`/api/sub-programs/${id}`, Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const update = data => {
  return httpClient
    .put(`/api/sub-programs/${data.acps_id}`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const destroy = id => {
  return httpClient
    .delete(`/api/sub-programs/${id}`)
    .then(response => Promise.resolve(response.data))
}

export const mainProgram = (Options = {}) => {
  return httpClient
    .get('/api/sub-programs/main-programs')
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const cardTemplate = (Options = {}) => {
  return httpClient
    .get('/api/sub-programs/card-templates')
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export default {
  get,
  find,
  store,
  update,
  destroy,
  mainProgram,
  cardTemplate
}
